module.exports = __webpack_public_path__ + "static/offsetpanel1-d160382b5eeab2d92447220699441dd7.png";